export enum QuickActionEnum {
  FLOW_TEMPLATE = 'flow_template',
  VENDOR = 'vendor',
  PROJECT_TYPE = 'project_type',
}
